import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';

import { CdwDrawerContentComponent } from './cdw-drawer-content/cdw-drawer-content.component';

@NgModule({
  imports: [CommonModule, MaterialLibraryModule, MatSidenavModule],
  declarations: [CdwDrawerContentComponent],
  exports: [CdwDrawerContentComponent],
})
export class CdwDrawerContentModule {}
